import httpClient from '@/shared/http-auth-data-client';

const appRelativeUrl = '/OutageSettings';
export default {
  getOutageInfo: () => httpClient.get(`${appRelativeUrl}`)
    .then((resp) => resp.data).catch((error) => {
      console.error(error);
      return null;
    }),
};
